import React from 'react'
import { useCallback } from "react";
import CircularProgress from '@material-ui/core/CircularProgress'

export default function SearchBox(props) {
    
    const onSearchClick = useCallback(() => {
        if (!props.isSearching) {
            props.onSearchClick();
        }
    }, [props]);

    const onClearClick = useCallback(() => {
        props.onClearClick();
    }, [props]);

    const onKeyPress = useCallback((e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onSearchClick();
        }
    }, [onSearchClick]);

    return (
        <div className="searchbox">

            <div className="searchbox-toggle-container"> 
                <button className="searchbox-toggle-button" onClick={props.onToggleClick}>
                    <i className={props.searchPanelVisible ? "bi bi-caret-up-fill" : "bi bi-caret-down-fill"}></i>
                </button>
            </div>

            <input type="search"
                value={props.keyword}
                onChange={props.onChangeKeyword}
                onKeyPress={onKeyPress}
                className="searchbox-text"
                placeholder="キーワードで検索"
                autoFocus />
            <div className="searchbox-searchbutton-container">
                <button className="searchbox-searchbutton" onClick={onSearchClick}>
                    <i className="bi bi-search"></i>
                </button>
            </div>
            <div className="searchbox-clearbutton-separator"></div>
            <div className="searchbox-clearbutton-container">
                {props.isSearching ?
                    <div className="searchbox-progress">
                        <CircularProgress size={26} />
                    </div>
                    :
                    <button className="searchbox-clearbutton" onClick={onClearClick}>
                        <i className="bi bi-x-lg" style={{ fontSize: '0.8em' }}></i>
                    </button>
                }
            </div>
        </div>

    );
}
